/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Sort_By_Priority_AriaInputs */



/**
* | output |
* | --- |
* | "Sort by priority" |
*
* @param {Explorer_Table_Sort_By_Priority_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_sort_by_priority_aria = /** @type {((inputs?: Explorer_Table_Sort_By_Priority_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Sort_By_Priority_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Sort by priority")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sort by priority")
	return /** @type {LocalizedString} */ ("Sort by priority")
});